import Breadcrumb from "../utlis/Breadcrumb";
import HeadingPage from "../utlis/HeadingPage";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
function Contact() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Contact Us"
          path="Contact Us"
        />
      </div>
      <div className="innerbody ">
        <div className="container-fluid">
          <div className="row ">
            <div className="col-xl-6 col-lg-12 col-12 order-xl-1 order-2">
              <div className="contact-info-wrapper">
                <div className="contact-info-box">
                  <div className="contact-icon">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/email.png"
                      alt="Email"
                    />
                  </div>
                  <div className="contact-content">
                    <h4>E-MAIL US</h4>
                    <p>carmelsar@gmail.com</p>
                  </div>
                </div>

                <div className="contact-info-box">
                  <div className="contact-icon">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/phone.png"
                      alt="Phone"
                    />
                  </div>
                  <div className="contact-content">
                    <h4>LET'S TALK</h4>
                    <p>918274010397</p>
                  </div>
                </div>

                <div className="contact-info-box">
                  <div className="contact-icon">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/location.png"
                      alt="Location"
                    />
                  </div>
                  <div className="contact-content">
                    <h4>Address Details</h4>
                    <p>
                      Carmel School Sarangabad, B.B.T Road, Maheshtala Kolkata –
                      700137
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6 col-lg-12 col-12 order-xl-2 order-1">
              <div className="contact-map-card about-image-card">
                <div className="contact-map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d58981.53343931561!2d88.209192!3d22.491204!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a027c357ca4e321%3A0x7acd00b1776349d4!2sCarmel%20School!5e0!3m2!1sen!2sin!4v1788867020167!5m2!1sen!2sin"
                    title="School Location"
                    loading="lazy"
                    allowFullScreen
                    referrerPolicy="strict-origin-when-cross-origin"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Contact;
